<template>
    <div class="indexList">
        <div class="haveContent" id="haveContent" v-if="listAllData">
            <mescroll-vue ref="mescroll" :up="mescrollUp" @init="mescrollInit">
                <!-- 轮播图 -->
                <div class="swiperBox" v-if="listAllData.hds_list&&listAllData.hds_list.length">
                    <div class="swiper-container">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" v-for="(item,index) in listAllData.hds_list" :key="index">
                                <div class="thumbImg">
                                    <img :src="item.thumb.split(',')[0]" alt="">    
                                </div>
                                <!-- <div class="titleBunner">
                                    {{item.title}}
                                    <div class="titleIndex">-<span>0{{index + 1}}</span>-</div>   
                                </div> -->
                            </div>
                        </div>
                        <div class="swiper-pagination"></div>
                    </div>
                </div>
                <!-- <div class="outLinkerContent">
                    <div class="outLinkerContentBox">
                        <div class="outLinkerPer" v-for="(item,index) in listAllData.newxmlbList" :key="index" @click="classificationDetails(item)">
                            <div class="outLinkerPerPer">
                                <img :src="item.thumb" alt="">
                            </div>
                            <p class="outLinkerPerTitle">{{item.title}}</p>
                        </div>
                    </div>
                </div> -->
                <div class="class_body">
                    <div class="class_list">
                        <img src="../../assets/images/amedia.png" alt="">
                        <span class="class_content">媒体报道</span>
                        <!-- <span class="class_btn">查看详情</span> -->
                    </div>
                    <div class="class_list">
                        <img src="../../assets/images/army.png" alt="">
                        <span class="class_content">队伍建设</span>
                        <!-- <span class="class_btn">查看详情</span> -->
                    </div>
                    <div class="class_list">
                        <img src="../../assets/images/athree.png" alt="">
                        <span class="class_content">活动招募</span>
                        <!-- <span class="class_btn">查看详情</span> -->
                    </div>
                    <div class="class_list">
                        <img src="../../assets/images/ashall.png" alt="">
                        <span class="class_content">积分商城</span>
                        <!-- <span class="class_btn">查看详情</span> -->
                    </div>
                    <div class="class_list">
                        <img src="../../assets/images/sumbol.png" alt="">
                        <span class="class_content">志愿典型</span>
                        <!-- <span class="class_btn">查看详情</span> -->
                    </div>
                </div>
                <div class="data_all">
                    <img src="../../assets/images/numall.png" alt="">
                    <div class="sum_body">
                        <div v-for="(item,index) in 4" :key="index">
                            <div class="sum_list">
                                <span class="sum_content">1256</span>
                                <span class="sum_content_two">志愿者人数</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="wenming_img">
                        <img src="../../assets/images/astart.png" alt="">
                        <span>文明实践进行时</span>
                    </div>
                    <div class="wenming_body">
                        <div class="wenming_wrapper" v-for="(item,index) in 2" :key="index">
                            <div class="wenming_list">
                                <img src="../../assets/images/weatherBc1.jpg" alt="">
                                <span class="wenming_content">瀛洲镇开展“老年健康宣传周”活动</span>
                                <span class="wenming_content_two">瀛洲镇开展“老年健康宣传周”活动</span>
                            </div>
                            <img class="zhaomu_img" src="../../assets/images/zhaomuing.png" alt="">
                        </div>
                    </div>
                </div>
                <!-- 置顶 -->
                <roofPlacement :listcontent="listAllData.stickList" v-if="listAllData&&listAllData.stickList"></roofPlacement>
                <!-- 新闻列表 -->
                <div class="newsBox">
                    <div class="borderBox"></div>
                    <newslist :listcontent="newsDataList"></newslist>
                </div>
            </mescroll-vue>
        </div>
        <loading :iscomplete="listAllData?false:true" ></loading>
    </div>
</template>
 
<script>
import Swiper from 'swiper';
import '../../assets/swiper.min.css';
import newslist from './NewsList.vue' //新闻列表
import loading from './loading.vue' //加载动画
import roofPlacement from './roofPlacement.vue'
import MescrollVue from 'mescroll.js/mescroll.vue' //上拉加载，下拉刷新

export default {
    props: {
        currentdisplay:{
            type: Number,
            default:()=>1, //必须是一个函数
			required: false,  //不是必填项
        },
        myIndex:{
            type: Number,
            default:()=>1, //必须是一个函数
			required: false,  //不是必填项
        }
    },
    data(){
        return{
            listAllData:null, //页面数据
            newsDataList:[], //新闻列表
            swiperContent:null, //轮播图
            mescroll:null, // mescroll实例对象
            mescrollUp: {
                callback: this.upCallback, // 上拉回调,此处可简写; 相当于 callback: function (page, mescroll) { getListData(page); }
                page: {
                    num: 1, // 当前页码,默认0,回调之前会加1,即callback(page)会从1开始
                    size: 10 // 每页数据的数量
                },
                htmlLoading: '<p class="upwarp-progress mescroll-rotate"></p><p class="upwarp-tip">加载中..</p>',
                htmlNodata: '<p class="upwarp-nodata">-- 到底啦 --</p>',
                noMoreSize: 5, // 如果列表已无数据,可设置列表的总数量要大于等于5条才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
                toTop: {
                    src: require('../../assets/mescroll/mescroll-totop.png') // 回到顶部按钮的图片路径,支持网络图
                },
                auto:false,
                lazyLoad: {
                    use: false // 是否开启懒加载,默认false
                }
            }
        }
    },
    components:{
        newslist,  //新闻列表
        loading,
        MescrollVue,
        roofPlacement //置顶
    },
    watch: {
        // 如果 `question` 发生改变，这个函数就会运行
        currentdisplay:{
            handler:function (newData) {
                if(!this.listAllData){
                    if(newData==this.myIndex){
                       // this.indexListDataObain();
                    }
                }
            },
            immediate: true
        }
    },
    methods:{
        // 导航接口
		indexListDataObain(){
			this.$http.post(this.phplinkTwo + 'app/index.php?id=xinbanshouye&pageid=1&time='+new Date().getTime())
            .then(resp=>{
                console.log(resp.data);
                if(resp.data.status=='ok'){
                    this.listAllData=resp.data;
                    this.newsDataList=resp.data.newslist;             
                    this.$nextTick(()=>{
                        this.InitializationSwiper();
                    })
                }
            });
        },
        // 轮播图
        InitializationSwiper(){
            if(this.swiperContent){
                this.swiperContent.destroy();
            }
            var that=this;
            this.swiperContent = new Swiper ('.swiper-container', {
                direction: 'horizontal', // 垂直切换选项
                loop: true, // 循环模式选项
                touchMoveStopPropagation : true, //阻止事件冒泡
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                },
                on:{
                    click:function(){
                        var x;
                        if(this.clickedIndex==that.listAllData.hds_list.length+1){
                            x=that.listAllData.hds_list[0];
                        }else if(this.clickedIndex==0){
                            x=that.listAllData.hds_list[that.listAllData.hds_list.length-1];
                        }else{
                            x=that.listAllData.hds_list[this.clickedIndex-1];
                        }
                        var link;
                        if(x.matrix_judge==1){
                            link=window.location.href.split("#/")[0]+"#/detailsTwo?id="+x.medid_id+'&judge'; //链接
                        }else{
                            if(x.linkerapp){
                                link=x.linkerapp; //链接
                            }else{
                                link=window.location.href.split("#/")[0]+"#/detailsTwo?id="+x.id; //链接
                            }
                        }
                        window.location.href=link;
                        // that.linkPhone({url: link,title:x.title});
                    }
                }
            })    
        },
        mescrollInit (mescroll) {
            this.mescroll = mescroll
        },
        // 上拉回调 page = {num:1, size:10}; num:当前页 ,默认从1开始; size:每页数据条数,默认10
        upCallback (page, mescroll) {
            var pageNum = page.num; // 页码, 默认从1开始 如何修改从0开始 ?
            // var pageSize = page.size; // 页长, 默认每页10条        
            this.$http.get(this.phplinkTwo + 'app/index.php?id=xinbanshouye' + '&pageid='+pageNum+"&time="+new Date().getTime()) //调接口
            .then(resp=>{
                if(resp.data.status=='ok'){
                    if (page.num === 1) {
                        this.listAllData=resp.data;
                        this.newsDataList = [];
                        if(this.listAllData.hds_list){
                            this.$nextTick(()=>{
                                this.InitializationSwiper();
                            })
                        }
                    }
                    if(resp.data.newslist){
                        this.newsDataList=this.newsDataList.concat(resp.data.newslist);
                    }
                }else{
                    // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
                    mescroll.endErr()
                }
                // mescroll.endByPage(resp.data.newslist.length,resp.data.total);
                // console.log(resp.data);
                this.$nextTick(()=>{
                    if(resp.data.newslist){
                        mescroll.endSuccess(resp.data.newslist.length);
                    }else{
                        mescroll.endSuccess(0);
                    }
                    // if (page.num === 1) {
                    //     this.InitializationSwiper()
                    // }
                })
            }).catch(()=>{
                // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
                mescroll.endErr()
            });
        },
        // 进入分类
        classificationDetails(item){
            // console.log(item);
            var link; //跳转链接
            if(item.outlinker){
                link=item.outlinker;
            }else if(item.projectmarks=="diandan"){ //群众点单
                link=window.location.href.split("#/")[0]+"#/massorder"; //链接
            }else if(item.projectmarks=="zhaomu"){ //活动招募
                link=window.location.href.split("#/")[0]+"#/voluntaryRecruitment"; //链接
            }else if(item.projectmarks=="xuexi"){ //学习园地
                link=window.location.href.split("#/")[0]+"#/study?datalink="+item.linkurl; //链接
            }else if(item.projectmarks=="shop"){ //积分商城
                link=window.location.href.split("#/")[0]+"#/shoppingMall/commodity"; //链接
                this.linkPhone({ //不需要导航头
                    url: link,
                    title: item.title,
                    isHideTitle:true
                });
                return false;
            }else{  //阵地建设
                link=window.location.href.split("#/")[0]+"#/bulid?datalink="+item.linkurl; //链接
            }
            window.location.href = link;
            // 在APP上另打开一个页面
            // this.linkPhone({
            //     url: link,
            //     title: item.title
            // });
        }   
    }
}
</script>

<style scoped>
    .indexList{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .swiper-container {
        --swiper-pagination-color: #D81920;
    }
    .indexList .swiper-container {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0px;
        left: 0px;
    }  
    .swiperBox{
        width: 100%;
        padding-bottom: 60%;
        position: relative
    }
    .outLinkerContent{
        width: 100%;
        padding-bottom: 20%;
        position: relative;
        /* margin-top: 15px; */
    }
    .outLinkerContentBox{
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
    }
    .outLinkerPer{
        width: 20%;
        height: 80%;
        /* text-align: center; */
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
    }
    .outLinkerPerPer {
        width: 100%;
        height: 56%;
    }
    .outLinkerPerPer  img{
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    .outLinkerPerTitle{
        width: 100%;
        /* line-height: 25px; */
        font-size: 0.28rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
    }
    .class_body {
        display: flex;
        /* flex-wrap: wrap; */
        margin-top: 2vw;
        justify-content: space-between;   
    }
    .class_list {
        border-radius: 5px;
        width: 20vw;
        /* height: 35vw; */
        /* background:#F7ECE2; */
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;
        margin-bottom: 2vw;
    }
    .class_content {
        /* width: 28vw; */
        /* text-align: center; */
        /* margin: 2vw 0; */
        font-size: 4vw;
        /* font-weight: bold; */
    }
    .class_btn {
        width: 16vw;
        background: #F61729;
        color: #fff;
        padding: 1px 5px;
        border-radius: 7px;
    }
    .class_list img {
        width: 13vw;
    }
    .data_all {
        padding: 0 3vw;
        margin-bottom: 3vw;
    }
    .data_all img {
        width: 100%;
        height: 13vw;
    }
    .sum_body {
        display: flex;
        justify-content: space-around;
        border-radius: 8px;
        margin-top: -3vw;
        border: 1px solid #E9E6E6;
    }
    .sum_list {
        width: 20vw;
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;
        margin: 2vw 0;
        border-right: 1px solid #C2C2C2;
        padding: 0 5px;
    }
    .sum_list:last-child {
        border-right: 0;
    }
    .sum_content {
        margin: 1vw 0;
        font-size: 5vw;
        font-weight: bold;
    }
    .sum_content_two {
        font-size: 4vw;
        color: #939393;
    }
    .wenming_img {
        display: flex;
        align-items: center;
        font-size: 5vw;
        font-weight: bold;
        padding: 2vw 3vw;
    }
    .wenming_img img {
        width: 8vw;
        margin-right: 5px;
    }
    .wenming_body {
        display: flex;
        justify-content: space-around;
    }
    .wenming_wrapper {
        position: relative;
    }
    .wenming_list {
        width: 43vw;
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;
        margin-bottom: 2vw;
        border: 1px solid #E9E6E6;
    }
    .zhaomu_img {
        width: 20vw;
        position: absolute;
        top: 0;
    }
    .wenming_list img {
        width: 100%;
    }
    .wenming_content {
        /* width: 28vw; */
        /* text-align: center; */
        margin: 2vw 0;
        font-size: 5vw;
        padding-left: 2vw;
        font-weight: bold;
    }
    .wenming_content_two {
        margin: 2vw 0;
        font-size: 4vw;
        padding-left: 2vw;
        color: #939393;
    }
    .indexList .haveContent{
        width: 100%;
        height: 100%;
    }
    .indexList .thumbImg{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .indexList .thumbImg img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    } 
    .indexList .swiper-pagination-bullet{
        width: 20px;
        height: 3px;
        border-radius: 0px;
        background: #ababab;
        opacity: 1;
    }
    .indexList .swiper-pagination-bullet-active{
        background: #fff;
    }
    .indexList .titleBunner{
        position: absolute;
        width: 100%;
        height: 20%;
        bottom: 0px;
        color: #333;
        font-size: 0.28rem;
        font-weight: 700;
        padding: 0px 10px;
        box-sizing: border-box;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        background: #e6e6e6;
        padding-top: 5px;
    }
    .titleIndex{
        position: absolute;
        bottom: 0;
        right: 5px;
        font-size: 0.24rem;
        color: #ababab;
    }
    .titleIndex span{
        color: red;
        font-weight: 100;
    }
    .borderBox {
        /* border:  solid#e6e6e6; */
        /* width: 100%; */
        /* margin-top: -50px; */
    }
    /* .newsBox{
        margin-top: 18px;
    } */
    .outSwiper{
        /* margin-top: 5px; */
        margin: 10px auto;
    }
    .my-swipe .van-swipe-item {
        font-size: 20px;
        display: flex;
        justify-content: space-between;
    }
    .imgBox{
        /* margin: 0 1px; */
        width: 20%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .imgBox img{
        width: 35px;
        height: 35px;
    }
    .outerTitle{
        font-size: 14px;
    }
</style>